import { anim, pv, stagger } from '../../../motion'
import { useCopy } from '../../i18n'
import { MaskText } from '../../showcase/stage/fx'
import { C } from '../shapes'

/*
 * Sechs graue Zeilen im Lebenslauf. Jede löst sich, wird zu einer farbigen
 * Aivy-Form und bekommt ein Talent als Beschriftung. Koordinaten in cqw der
 * Bühne (100 breit, 120 hoch).
 */
const BITS = [
  { x0: 14, y0: 50, w0: 62, x1: 6, y1: 6, s: 15, kind: 'circle', c: C.pink },
  { x0: 14, y0: 58, w0: 50, x1: 54, y1: 2, s: 17, kind: 'tri', c: C.yellow },
  { x0: 14, y0: 66, w0: 56, x1: 12, y1: 40, s: 14, kind: 'square', c: C.green },
  {
    x0: 14,
    y0: 78,
    w0: 44,
    x1: 64,
    y1: 50,
    s: 15,
    kind: 'circle',
    c: '#FFFFFF'
  },
  { x0: 14, y0: 86, w0: 58, x1: 4, y1: 78, s: 16, kind: 'tri', c: C.pink },
  { x0: 14, y0: 94, w0: 36, x1: 52, y1: 84, s: 14, kind: 'square', c: C.yellow }
]

const RADIUS = { circle: '50%', square: '24%', tri: '0%' }

/**
 * Auf Blau: Der Lebenslauf zeigt nur Stationen. Seine Zeilen werden zu
 * Talenten, dazu der Beleg aus der Fallstudie Frankfurt School.
 */
export default function PlCv() {
  const c = useCopy('lebenslauf')

  return (
    <div className='ap-cv'>
      <div className='ap-cv__copy'>
        <h2 className='ap-h1 ap-cv__before'>
          {c.before.map((line, i) => (
            <span key={line} className='ap-line'>
              <MaskText
                text={line}
                at={[0.02 + i * 0.05, 0.14 + i * 0.05]}
                out={[0.38, 0.46]}
              />
            </span>
          ))}
        </h2>
        <h2 className='ap-h1 ap-cv__after'>
          {c.after.map((line, i) => (
            <span key={line} className='ap-line'>
              <MaskText text={line} at={[0.46 + i * 0.05, 0.58 + i * 0.05]} />
            </span>
          ))}
        </h2>
        <div className='ap-cv__stat' style={anim({ at: [0.72, 0.8], y: 30 })}>
          <span className='ap-cv__stat-num'>{c.stat}</span>
          <span>
            <strong>{c.statLabel}</strong>
            <small>{c.statSource}</small>
          </span>
        </div>
      </div>

      <div className='ap-cv__stage'>
        <div className='ap-cv__card' style={pv('k', [0.32, 0.44])}>
          <span className='ap-cv__label'>{c.cv}</span>
          <span className='ap-cv__photo' />
          <span className='ap-cv__name' />
          <span className='ap-cv__role' />
          <span className='ap-cv__rule' />
          <span className='ap-cv__rule ap-cv__rule--b' />
        </div>
        {BITS.map((b, i) => (
          <span
            key={i}
            className={`ap-cv__bit ap-cv__bit--${b.kind}`}
            style={{
              '--x0': b.x0,
              '--y0': b.y0,
              '--w0': b.w0,
              '--x1': b.x1,
              '--y1': b.y1,
              '--s': b.s,
              '--r1': RADIUS[b.kind],
              '--c': b.c,
              ...pv('p', stagger(0.3, 0.03, 0.24, i)),
              ...pv('q', stagger(0.42, 0.03, 0.12, i))
            }}
          />
        ))}
        {BITS.map((b, i) => (
          <span
            key={c.talents[i]}
            className='ap-cv__talent'
            style={{
              left: `${b.x1 + b.s + 2.5}cqw`,
              top: `${b.y1 + b.s / 2}cqw`,
              ...anim({ at: stagger(0.56, 0.025, 0.08, i), x: -16, y: 0 })
            }}
          >
            {c.talents[i]}
          </span>
        ))}
      </div>
    </div>
  )
}
